import React, { Dispatch, PropsWithChildren, useMemo } from 'react';
import {
  ReportsFiltersContext,
  ReportsFiltersDispatchContext,
  ReportsViewModeContext,
  ReportsViewModeContextData,
} from './index';
import { ReportFilters, ViewMode } from '../../models/reports';

interface ReportsFiltersProviderProps {
  filters: ReportFilters | null;
  dispatch: Dispatch<Partial<ReportFilters> | null>;
}

export function filtersReducer(
  state: ReportFilters | null,
  payload: Partial<ReportFilters> | null
): ReportFilters | null {
  if (!payload && !state) return null;

  return payload ? { ...(state || ({} as ReportFilters)), ...payload } : null;
}

export function ReportsFiltersProvider(
  props: PropsWithChildren<ReportsFiltersProviderProps>
): JSX.Element {
  return (
    <ReportsFiltersContext.Provider value={props.filters}>
      <ReportsFiltersDispatchContext.Provider value={props.dispatch}>
        {props.children}
      </ReportsFiltersDispatchContext.Provider>
    </ReportsFiltersContext.Provider>
  );
}

export type ReportsViewModeProviderProps = {
  viewMode: ViewMode;
  setViewMode: Dispatch<React.SetStateAction<ViewMode>>;
};

export function ReportsViewModeProvider({
  children,
  ...props
}: PropsWithChildren<ReportsViewModeProviderProps>): JSX.Element {
  const value = useMemo<ReportsViewModeContextData>(
    () => [props.viewMode, props.setViewMode],
    [props.viewMode, props.setViewMode]
  );

  return (
    <ReportsViewModeContext.Provider value={value}>
      {children}
    </ReportsViewModeContext.Provider>
  );
}
